var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "200px",
    height: "200px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ebb954",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(2.56,2.56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.144,56.668l9.597,-9.601c5.208,-5.207 5.205,-13.652 0.003,-18.853l-14.31,-14.31c-5.208,-5.207 -13.658,-5.208 -18.86,-0.001l-14.31,14.31c-5.202,5.213 -5.199,13.651 0,18.859l9.596,9.596l-19.193,19.193l11.784,2.35l2.356,11.791l19.193,-19.193l19.189,19.193l2.36,-11.791l11.783,-2.356zM67.722,31.619l1.309,1.309c2.594,2.598 2.598,6.825 -0.004,9.425l-9.6,9.598l-4.71,-4.71l9.6,-9.6c1.725,-1.725 2.825,-3.82 3.405,-6.022zM50.003,42.526l-9.599,-9.598c5.299,-5.303 13.893,-5.303 19.192,-0.003zM45.287,18.618c1.26,-1.261 2.933,-1.953 4.716,-1.951c1.781,-0.002 3.457,0.691 4.717,1.951l9.59,9.593c-7.9,-7.904 -20.716,-7.904 -28.619,-0.001zM34.899,76.479l-0.781,-3.933l-3.926,-0.787l10.381,-10.378l4.714,4.714zM65.889,72.554l-0.791,3.926l-34.121,-34.125c-2.598,-2.598 -2.594,-6.83 0.004,-9.429l1.305,-1.307c0.583,2.201 1.68,4.295 3.408,6.024l34.118,34.123z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.8fe94bf319a1ccd678d9c39a45e6c7d0.svg";
export { ForwardRef as ReactComponent };